import { type FC } from 'react';

interface StatCardProps {
  icon: string;
  label: string;
  value: string | number;
  sub?: string;
  accent?: boolean;
}

const StatCard: FC<StatCardProps> = ({ icon, label, value, sub, accent = false }) => (
  <div className={`rounded-2xl p-5 flex items-start gap-4 ${accent ? 'bg-accent-50 border border-accent-200/60' : 'bg-background-100/80 border border-background-200/60'}`}>
    <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${accent ? 'bg-accent-500 text-accent-950' : 'bg-primary-100 text-primary-600'}`}>
      <i className={`${icon} text-lg`}></i>
    </div>
    <div className="min-w-0">
      <p className="text-xs text-foreground-500 mb-0.5">{label}</p>
      <p className={`text-2xl font-bold ${accent ? 'text-accent-700' : 'text-foreground-900'} font-heading`}>{value}</p>
      {sub && <p className="text-xs text-foreground-500 mt-0.5">{sub}</p>}
    </div>
  </div>
);

export default StatCard;